import React from 'react';
import { SxProps, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { styles } from './read-only-wrapper-helper';

interface ReactOnlyWrapperProps {
    children: React.ReactNode;
    customTextContainerStyles?: SxProps;
}
const ReadOnlyWrapper = ({
    children,
    customTextContainerStyles,
}: ReactOnlyWrapperProps): React.JSX.Element => {
    return (
        <Box id='read-only-container' sx={styles.readyOnlyContainer}>
            <Box
                id='read-only-text-container'
                sx={customTextContainerStyles ?? styles.textContainer}
            >
                <Typography style={styles.text}>READ ONLY</Typography>
            </Box>
            {children}
        </Box>
    );
};

export default ReadOnlyWrapper;
